import React, { useCallback } from 'react';

import { PreviewPanelsProvider } from '@atlassian/preview-panels-api';

import { useCloseAllOpenSidePanels } from './useCloseAllOpenSidePanels';

export const ConfluencePreviewPanelsProvider = ({ children }: { children: React.ReactNode }) => {
	const { closeAllOpenSidePanels } = useCloseAllOpenSidePanels();

	const onPreviewPanelOpen = useCallback(() => {
		// Add any additional logic here for opening preview panels.
	}, []);

	const onPreviewPanelClose = useCallback(() => {
		// Add any additional logic here for closing preview panels.
		closeAllOpenSidePanels();
	}, [closeAllOpenSidePanels]);

	return (
		<PreviewPanelsProvider
			onPreviewPanelOpen={onPreviewPanelOpen}
			onPreviewPanelClose={onPreviewPanelClose}
		>
			{children}
		</PreviewPanelsProvider>
	);
};
